import download from '../assats/chart/chartToolbar/export.svg';
import searchZoomIn from '../assats/chart/chartToolbar/search-zoom-in.svg';
import searchZoomOut from '../assats/chart/chartToolbar/search-zoom-out.svg';
import hand from '../assats/chart/chartToolbar/Vector.svg';
import rest from '../assats/chart/chartToolbar/back-square.svg';
export function useChartToolbar() {
  return {
    show: true,
    tools: {
      download: `<img src="${download}" />`,
      zoomin: `<img src="${searchZoomIn}" />`,
      zoomout: `<img src="${searchZoomOut}" />`,
      pan: `<img src="${hand}" />`,
      reset: `<img src="${rest}" />`,
      zoom: false,
    },
  };
}
